import {
  getAppointmentsByProviderGuidAndStartDate,
  getAppointmentsByServiceDateRange,
} from '@ax/service';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useGetAppointmentsByServiceDateRangeApi(
  date: string,
  isProviderAdmin: boolean,
  providerGuid: string,
) {
  const memoizedIsProviderAdmin = useMemo(() => isProviderAdmin, [isProviderAdmin]);

  return useQuery({
    queryKey: ['appointmentsByServiceDate', date],
    queryFn: () =>
      memoizedIsProviderAdmin
        ? getAppointmentsByProviderGuidAndStartDate({ providerGuid, date })
        : getAppointmentsByServiceDateRange({ date }),
    onError: (error: Error) => {
      console.log(error.message);
    },
    enabled: !!date && (!memoizedIsProviderAdmin || (memoizedIsProviderAdmin && !!providerGuid)),
    refetchInterval: 3000,
    cacheTime: 0,
  });
}
